// Angular
import { Directive, HostListener, inject, Input } from '@angular/core';

// Material
import { MatTabGroup } from '@angular/material/tabs';

// Project
import { WkInfodrawerService } from '../../services/wk-info-drawer.service';

@Directive({
  selector: '[acaTabsHoverAnimation]',
  standalone: true,
})
export class WkTabsHoverAnimationDirective {
  @Input() tabGroup: MatTabGroup;
  @Input() tabIndex: number;
  constructor() {}

  private readonly wkInfodrawerService = inject(WkInfodrawerService);

  @HostListener('mouseenter') onMouseEnter() {
    const currentIndex = this.tabIndex;
    // select all the tabs in the group
    const fatherElement: HTMLElement =
      this.tabGroup._elementRef.nativeElement.querySelector(
        '.mat-mdc-tab-labels'
      ).childNodes[currentIndex] as HTMLElement;
    // get the client with for manage the initial position
    this.tabGroup._elementRef.nativeElement.style.setProperty(
      '--size-tabs-container',
      `${fatherElement?.clientWidth}px`
    );
    // check the condition to add the animation class
    if (this.wkInfodrawerService.gettabAnimationCurrent() < currentIndex) {
      fatherElement.classList.remove('move-from-left');
      fatherElement.classList.add('move-from-right');
    } else if (
      this.wkInfodrawerService.gettabAnimationCurrent() > currentIndex
    ) {
      fatherElement.classList.remove('move-from-right');
      fatherElement.classList.add('move-from-left');
    }
    // update the last index touched to the current one
    this.wkInfodrawerService.settabAnimationCurrent(currentIndex);
  }
}
